/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum InformationGatheringSexAssignedAtBirth {
  Female = 'female',
  Male = 'male',
  PreferNotToSay = 'prefer-not-to-say'
}
